import './Projects.scss';
import { projects } from '../../../helpers/constants';

import ProjectContainer from "./ProjectContainer";
import RenderIf from '../../RenderIf';
import Spacer from '../../Spacer';

const Projects = ({ projectsSection }: { projectsSection: React.RefObject<HTMLElement> }) => {
    return (
        <section id='projects' ref={projectsSection}>
            <div className='projects-list'>
                {
                    projects.map((e, i) =>
                        <div className="project-container-align" key={i}>
                            <RenderIf condition={i % 2 !== 0}>
                                <Spacer />
                            </RenderIf>
                            <ProjectContainer {...e} rightAlign={i % 2 !== 0} isLast={i === projects.length - 1} />
                            <RenderIf condition={i % 2 === 0}>
                                <Spacer />
                            </RenderIf>
                        </div>
                    )
                }
            </div>
        </section>
    )
}

export default Projects;
